<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.first-name' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.last-name' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.company' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.job-function' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.phone' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationcustomercontact.email' | translate }}</strong>
      </span>
    </td>
  </tr>
  <tr *ngFor="let customer of customerContacts">
    <td>
      <span>{{ customer.FirstName }}</span>
    </td>
    <td>
      <span>{{ customer.LastName }}</span>
    </td>
    <td>
      <span>{{ customer.Company }}</span>
    </td>
    <td>
      <span>{{ customer.JobFunction }}</span>
    </td>
    <td>
      <span>{{ customer.Phone }}</span>
    </td>
    <td>
      <span>{{ customer.Email }}</span>
    </td>
  </tr>
</table>
